import { apiService } from "../../common/api/apiService";
import { API_ENDPOINTS } from "../../common/api/apiEndpoints";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LOADING_STATUS } from "../../common/constants";
import { RootState } from "../../app/store";
import {
  getAccommodationDetailsBasicAsync,
  getAccommodationImagesAsync,
} from "../../pages/AccommodationsPage/accommodationSlice";

export interface AddressResponse {
  id: string;
  isPrimary: boolean;
  description: string;
  postCity: string;
  postStreetAddress: string;
  additionalAddressLine: string;
  postCode: string;
  countryId: string;
}

export interface IdentityState {
  accommodationAddress: AddressResponse;
  accommodationAddressLoadingStatus:
    | LOADING_STATUS.IDLE
    | LOADING_STATUS.LOADING
    | LOADING_STATUS.FAILED;
}
const initialState: IdentityState = {
  accommodationAddress: null,
  accommodationAddressLoadingStatus: LOADING_STATUS.IDLE,
};

export const getIdentityAddressDetailsAsync = createAsyncThunk(
  "users/getIdentityAddressDetailsAsync",
  async (addressId: string, { rejectWithValue }) => {
    const addressInfo = await apiService.get(
      API_ENDPOINTS.IDENTITY.GET_ACCOMMODATION_ADDRESS +
        "?addressId=" +
        addressId,
    );
    return { addressInfo };
  },
);

const identitySlice = createSlice({
  name: "identity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIdentityAddressDetailsAsync.pending, (state) => {
        state.accommodationAddressLoadingStatus = LOADING_STATUS.LOADING;
      })
      .addCase(getIdentityAddressDetailsAsync.fulfilled, (state, action) => {
        state.accommodationAddressLoadingStatus = LOADING_STATUS.IDLE;
        state.accommodationAddress = action.payload.addressInfo.result;
      })
      .addCase(getIdentityAddressDetailsAsync.rejected, (state) => {
        state.accommodationAddressLoadingStatus = LOADING_STATUS.FAILED;
      });
  },
});

export const selectAccommodationAddress = (state: RootState) =>
  state.identity.accommodationAddress;

export const selectAccommodationAddressLoadingStatus = (state: RootState) =>
  state.identity.accommodationAddressLoadingStatus;

export default identitySlice.reducer;
